import { useEffect, useState } from 'react';
import { fetchProjectLookup, fetchTeamMemberLookup, type ProjectLookup, type TeamMemberLookup } from '@/lib/entity-api';

/**
 * The company's active projects and people for a screen's dropdowns and name columns, from the lookups API
 * (`/api/lookups/*`) -- the one place screens get them, never from Supabase. Loaded once `enabled` (company known).
 */
export function useCompanyLookups(enabled: boolean, opts: { includeInactiveProjects?: boolean } = {}) {
  const { includeInactiveProjects = false } = opts;
  const [projects, setProjects] = useState<ProjectLookup[]>([]);
  const [users, setUsers] = useState<TeamMemberLookup[]>([]);

  useEffect(() => {
    if (!enabled) return;
    fetchProjectLookup({ includeInactive: includeInactiveProjects }).then(setProjects).catch((error) => console.error('Error fetching projects:', error));
    fetchTeamMemberLookup().then(setUsers).catch((error) => console.error('Error fetching users:', error));
  }, [enabled, includeInactiveProjects]);

  return { projects, users };
}
